// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gr4i","type":"styles_type__3Pieh","choices":"styles_choices__1YW64"};